export const listCargosPCCE = [
    {
        id: 1,
        cargos: 'Escrivão'
    },
    {
        id: 2,
        cargos: 'Inspetor'
    },
    {
        id: 3,
        cargos: 'Delegado'
    },
];

export const listCargosPMCE = [
    {
      id: 1,
      cargos: 'Teste1'
    },
    {
      id: 2,
      cargos: 'Teste2'
    },
    {
      id: 3,
      cargos: 'Teste3'
    },
];
  
export const listCargosSSPDS = [
    {
        id: 1,
        cargos: 'Cargo1'
    },
    {
        id: 2,
        cargos: 'Cargo2'
    },
    {
        id: 3,
        cargos: 'Cargo3'
    },
];

export const listCargosCBMCE = [
    {
        id: 1,
        cargos: 'CargoA'
    },
    {
        id: 2,
        cargos: 'CargoB'
    },
    {
        id: 3,
        cargos: 'CargoC'
    },
];

export const listCargosPEFOCE = [
    {
        id: 1,
        cargos: 'Posição1'
    },
    {
        id: 2,
        cargos: 'Posição2'
    },
    {
        id: 3,
        cargos: 'Posição3'
    },
];

export const listCargosSUPESP = [
    {
        id: 1,
        cargos: 'Função1'
    },
    {
        id: 2,
        cargos: 'Função2'
    },
    {
        id: 3,
        cargos: 'Função3'
    },
];

export const listCargosAESP = [
    {
        id: 1,
        cargos: 'Job1'
    },
    {
        id: 2,
        cargos: 'Job2'
    },
    {
        id: 3,
        cargos: 'Job3'
    },
];

export const listCargosOUTROS = [
    {
        id: 1,
        cargos: 'Outro1'
    },
    {
        id: 2,
        cargos: 'Outro2'
    },
    {
        id: 3,
        cargos: 'Outro3'
    },
];
  